// custom-tag.component.ts
import { Component, Input } from '@angular/core';

@Component({
  selector: 'custom-tag',
  templateUrl: './custom-tag.component.html',
  styleUrls: ['./custom-tag.component.less']
})
export class CustomTagComponent {
  @Input() content: string = '';
  @Input() backgroundColor: string = ''; 
  @Input() fontColor: string = ''; 
  @Input() borderColor: string = '';
}
